// import { HttpAdapter } from "../../../config/http/http.adapter";
import { HttpAdapter } from '../../../config/http/http.adapter';
import { BalanceTraceResponse } from '../../../infraestructure/interfaces/balance-trace.interface';
import { BalanceTraceMapper } from '../../../infraestructure/mappers/balance-trace.mapper';
import { BalanceTraceChart } from '../../entities/general/BalanceTraceChart.entity';
import { handleError } from '../../handle-error/handleError';
import moment from 'moment';

// Fecha actual en el formato deseado
const currentDate = moment().format('YYYY-MM-DD');

// Fecha restando 12 meses
const originDate = moment().subtract(12, 'months').format('YYYY-MM-DD');

interface Props {
  clientId: string;
  dateFrom: string | Date;
  dateTo: string | Date;
  accountNumber?: string;
}

export const BalanceTraceUseCases = async (
  fetcher: HttpAdapter,
  props: Props
): //   fetcher: HttpAdapter
Promise<BalanceTraceChart> => {
  try {
    const {
      clientId,
      dateFrom = originDate,
      dateTo = currentDate,
      accountNumber,
    } = props;

    const requestData: Record<string, string> = {
      clientId: `${clientId}`,
      dateFrom: `${dateFrom}`,
      dateTo: `${dateTo}`,
    };

    if (accountNumber) {
      requestData.accountNumber = `${accountNumber}`;
    }

    const response = await fetcher.post<BalanceTraceResponse>(
      '/data-ms/balance-trace',
      requestData
    );

    return BalanceTraceMapper.fromResponseToEntity(response);
  } catch (error: any) {
    const processedError = handleError(error);
    console.error('Error procesado:', processedError);
    throw new Error(`${processedError.message} ${processedError.status}`);
  }
};
